import cs from './cs'

export default {
    cs: cs,
}